import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('The URL to the backend');
